import { render } from "./AncestryDetail.vue?vue&type=template&id=04d8fe29&scoped=true"
import script from "./AncestryDetail.vue?vue&type=script&lang=js"
export * from "./AncestryDetail.vue?vue&type=script&lang=js"

import "./AncestryDetail.vue?vue&type=style&index=0&id=04d8fe29&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d8fe29"]])

export default __exports__